import classNames from 'classnames';

function Skeleton({ times, className }) {
    const outerClassNames = classNames(
        //Base Styling
        'relative', 
        'overflow-hidden',
        'bg-gray-200',
        'rounded',
        'mb-2.5',
        className
    );
    const innerClassNames = classNames(
        'animate-shimmer',
        'absolute',
        'inset-0',
        '-translate-x-full',
        'from-gray-200',
        'via-white',
        'to-gray-200'
    );
        
    const boxes = Array(times)
        .fill(0)
        .map((_, i)=> {
            return <div key={i} className={outerClassNames}>
                <div className={innerClassNames}/>
            </div>
    });
    return boxes;
}
export default Skeleton;